import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    standalone: false,
    name: 'timeDifference',
    
})
export class TimeDifferencePipe implements PipeTransform {

  transform(start: string, end: string): string {   
    const startDate:Date = new Date(start);
    const endDate:Date=new Date(end);

    if (startDate > endDate || !moment(startDate).isValid()||!moment(endDate).isValid()) {
      return ``;
    }

    const diffInMs = Math.abs(startDate.getTime() - endDate.getTime());
    // Convert milliseconds to minutes
    const diffInMinutes = Math.floor(diffInMs / 1000 / 60);

    if (diffInMinutes > 0) {
      const hours = Math.floor(diffInMinutes / 60);
      const remainingMinutes = diffInMinutes % 60;
      if (hours > 0) {
        return `${hours} Hr ${remainingMinutes} Min`;
      } else {
        return `${remainingMinutes} Min`;
      }
    }
    return '0 Min';
  }
}
